<label
    *ngFor="let item of items$ | async; trackBy: trackByValue"
    [title]="item.title || ''"
    [ngClass]="{
        selected: isSelected(item.value),
        'selected--single': isSelected(item.value) && !multiSelect,
        disabled: disabled || item.disabled,
    }"
    [attr.data-id]="item.id"
>
    <input
        [type]="multiSelect ? 'checkbox' : 'radio'"
        [name]="name"
        [value]="item.value"
        [checked]="isSelected(item.value)"
        (change)="disabled ? null : onChecked($event, item)"
        [disabled]="item.disabled"
    />
    <span class="img-wrapper">
        <ng-container [ngTemplateOutlet]="item.image"></ng-container>
    </span>
    <span class="label">
        <ng-container *ngIf="item.label">{{ item.label }}</ng-container>
        <ng-container *ngIf="!item.label" [ngTemplateOutlet]="item.ref"></ng-container>
    </span>
</label>
